import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const axios = require('axios');

export default new Vuex.Store({
	state: {
		isTitleEnterCode: 'Заполните ключ QR с карты',
		isStatusValidation: 'Ключ активации',
		isActiveFirstStep: true,
		isActiveSecondStep: false,
		isActiveThirdStep: false,
		
		//second step
		allowedModels: [],
		allowedModelsStatus: false,
		allowedModelsTitle: 'Серийный номер',
		transactionKey: '',
		isRateTitle: 'Тариф',
		isSelectedModel: ''
		
	},
	mutations: {
		setStatusCard(state, payload) {
			state.isStatusValidation = payload;
		},
		resetCard(state, payload) {
			console.log('payload', payload);
			state.isActiveFirstStep = payload;
			state.isActiveSecondStep = false;
			state.isActiveThirdStep = false;
			
			state.isStatusValidation = 'Ключ активации';
			state.isTitleEnterCode = 'Заполните ключ QR с карты';
			state.isRateTitle = 'Тариф'
			state.isSelectedModel = ''
		},
		setStatusSecondStep(state, payload) {
			state.isActiveSecondStep = payload;
			state.isActiveFirstStep = false;
		},
		setStatusThirdStep(state, payload) {
			state.isActiveThirdStep = payload;
			state.isActiveSecondStep = false;
		},
		setAllowedModels(state, payload) {
			state.allowedModels = payload;
		},
		setTransactionCode(state, payload) {
			state.transactionKey = payload;
		},
		setStatusAllowedModels(state, payload) {
			state.allowedModelsStatus = payload;
		},
		setTitleAllowedModels(state, payload) {
			state.allowedModelsTitle = payload;
		},
		setTitleEnterCode(state, payload) {
			state.isTitleEnterCode = payload;
		},
		setRateTitle(state, payload) {
			state.isRateTitle = payload;
		},
		setSelectedModel(state, payload) {
			state.isSelectedModel = payload.name;
		}
	},
	//BCD85852BD9F9093
	actions: {
		RESET_DATA({commit}) {
			commit('resetCard', true);
			commit('setStatusAllowedModels', false);
			commit('setAllowedModels', []);
		},
		CHECK_VALIDATION_CODE({commit}, code) {
			axios.get('https://warranty.tki.ltd/api/v1/card/validation', {
				params: {
					card: code
				}
			}).then(response => {
				if(response.status === 200) {
					if(response.data.status === 1) {
						let formatCode = code.split('-').join('').split(/(.{4})/).filter(O=>O);
						
						console.log('formatCode', formatCode);
						commit('setStatusSecondStep', true);
						commit('setAllowedModels', response.data.allowedModels);
						commit('setTransactionCode', response.data.transaction);
						commit('setTitleEnterCode', formatCode.join('-'));
						
					} else if (response.data.status === 2) {
						commit('setStatusCard', 'Такой карты нет!');
					} else if (response.data.status === 3) {
						commit('setStatusCard', 'Карта уже активирована!');
					} else if (response.data.status === 4) {
						commit('setStatusCard', 'Нельзя применить к карте');
					} else if (response.data.status === 5) {
						commit('setStatusCard', 'Устройство не найдено');
					} else if (response.data.status === 6) {
						commit('setStatusCard', 'Можно применить к карте');
					} else if (response.data.status === 7) {
						commit('setStatusCard', 'Карта успешно активирована');
					}
				}
				
			})
		},
		CHECK_SERIAL_NUMBER({state: state, commit}, code) {
			axios.get('https://warranty.tki.ltd/api/v1/device/validation', {
				params: {
					sn: code,
					transaction: state.transactionKey
				}
			}).then(response => {
				if(response.status === 200) {
					if(response.data.status === 6) {
						commit('setAllowedModels', response.data.device);
						commit('setStatusAllowedModels', true);
						commit('setRateTitle', code);
						response.data.device.forEach(data => {
							commit('setSelectedModel', data);
						})
						
					} else if (response.data.status === 5) {
						commit('setTitleAllowedModels', 'Неверный серийный номер');
					}
				}
			})
		},
		ACTIVATE_FINAL_CODE({state: state, commit}) {
			
			axios.post('https://warranty.tki.ltd/api/v1/card/activate', {
				transaction: state.transactionKey
			}).then(() => {
				commit('setStatusThirdStep', true);
			})
		}
	},
	modules: {}
});
